import cn from 'classnames'
import Link from 'next/link'
import React from 'react'
import type { ContentWriterInformation } from 'src/hooks/useContentWriterInformation'

import { Avatar } from '../global/Avatar/Avatar'

interface WriterTooltipModelProps {
  writer: ContentWriterInformation
}

const WriterTooltipModel: React.FC<WriterTooltipModelProps> = ({ writer }) => {
  const { name, url, originalAvatar, logo } = writer

  const badgeContent = (
    <>
      <Avatar
        size="24px"
        initialsTextSize="12px"
        url={originalAvatar || logo || ''}
        name={name}
        defaultMode="initials"
        border={originalAvatar ? 'circle' : 'no-border'}
        variant="turquoise"
        className="shrink-0 border-none"
      />
      <span className="writer-name text-[12px] font-semibold text-gray-800">{name}</span>
    </>
  )

  return (
    <div className="custom_tooltip insight-cards writer-author-tooltip z-[9999]">
      <div className="tooltip_inner_wrap relative">
        <ul>
          <li title={name}>
            <span className={cn('writer-author-badge inline-flex items-center gap-2')}>
              {url ? (
                <Link prefetch={false} title={name} href={url} className="inline-flex items-center gap-2">
                  {badgeContent}
                </Link>
              ) : (
                badgeContent
              )}
            </span>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default WriterTooltipModel
